<template>
    <Icon
        class="express-icon"
        icon="stopwatch"
    />
</template>

<script lang="ts" setup>
import Icon from '@/components/ui/icon/Icon.vue'
</script>

<style lang="scss" scoped>
.express-icon {
    border-radius: 50%;
    width: 32px;
    height: 32px;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    color: var(--slate);
    background: var(--frosted-glass-background);
    padding-right: 3px;
    font-size: 1.2rem;
}
</style>
